<template>
  <div style="max-width: 95%;" class="mx-auto mt-8">
    <v-btn to="/" dark class="blue-grey darken-3">Palaa etusivulle</v-btn>
    <v-card class="my-8" color="green" dark outlined>
      <v-card-title>
        <div v-if="!loadingCa">{{ catInfo.name }}</div>
        <div v-else>
          <v-skeleton-loader ref="skeleton" type="heading"></v-skeleton-loader>
        </div>
      </v-card-title>
      <v-card-text>
        <div v-if="!loadingCa">{{ catInfo.infoText }}</div>
        <div v-else>
          <v-skeleton-loader
            ref="skeleton"
            type="paragraph"
          ></v-skeleton-loader>
        </div>
      </v-card-text>
    </v-card>
    <v-progress-circular
      v-if="loadingCo"
      :size="80"
      :width="8"
      color="green"
      indeterminate
    />
    <h2 class="display-1" v-else-if="companies.length === 0">
      Ei yrityksiä tässä kategoriassa! :(
    </h2>
    <v-row v-else-if="!error">
      <v-col cols="12" md="6" lg="4" v-for="(c, i) in companies" :key="i">
        <v-card>
          <v-list-item three-line>
            <v-list-item-content>
              <div
                class="overline mb-4"
                v-if="
                  c.openHours[(new Date().getDay() + 6) % 7] !== 'Ei tiedossa'
                "
              >
                {{ openText(c) }}
              </div>
              <v-list-item-title class="headline mb-1 text-no-wrap">{{
                c.businessName
              }}</v-list-item-title>
              <!-- <v-list-item-subtitle>{{ c.infoText }}</v-list-item-subtitle> -->
              <v-expansion-panels flat>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    @click="
                      expansionPanels = {
                        ...expansionPanels,
                        [i]: !expansionPanels[i]
                      }
                    "
                    v-if="!expansionPanels[i]"
                  >
                    <v-row no-gutters>
                      <v-col cols="12">{{ c.infoText.slice(0, 150) }}...</v-col>
                      <v-col cols="12">
                        <v-btn text color="blue-grey lighten-3"
                          >Näytä enemmän</v-btn
                        ></v-col
                      >
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content
                    ><v-img
                      v-if="c.filestackHandle !== 'ef7GrvYSdGRfEOAR3a0u'"
                      max-height="200"
                      contain
                      :src="`https://cdn.filestackcontent.com/${c.filestackHandle}`"
                    ></v-img>
                    <div class="pt-4" v-html="htmlInfo(c)"></div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-list-item-content>

            <v-list-item-avatar
              v-if="
                c.filestackHandle !== 'ef7GrvYSdGRfEOAR3a0u' &&
                !expansionPanels[i]
              "
              tile
              size="80"
            >
              <v-img
                :src="`https://cdn.filestackcontent.com/${c.filestackHandle}`"
              ></v-img>
            </v-list-item-avatar>
          </v-list-item>

          <v-card-actions>
            <v-btn outlined class="ml-2" color="green" :to="`/yritys/${c.id}`"
              >Lue lisää / tilaa / aukioloajat</v-btn
            >
          </v-card-actions>
          <p
            class="px-4 pb-4 overline font-italic font-weight-light"
            style="
              font-size: 8px !important;
              line-height: 100%;
              letter-spacing: 0 !important;
            "
            v-if="showCopyrightnotice"
          >
            Ylläolevat tekijänoikeuksin suojatut merkit omistaa niiden omistaja.
            Tietojen oikeudellisuudesta vastaa {{ c.businessName }}. Yritys on
            antanut kirjallisen luvan esittää yllä olevat tiedot tällä sivulla.
          </p>
        </v-card>
      </v-col>
    </v-row>
    <v-alert text color="red" v-else>
      <b>Sivusto ei toimi järjestelmävirheen vuoksi</b> Ilmoita tästä
      sähköpostilla osoitteeseen vili@pysykotona.fi !
    </v-alert>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'Category',
  props: {
    category: String
  },
  computed: {
    showCopyrightnotice() {
      return store.getters['flags/showCopyrightnotice']
    }
  },
  mounted() {
    fetch('https://hallinta.kotona.kiuruvesi.net/fontend/catInfo')
      .then(res => res.json())
      .then(res => {
        if (res.find(x => x.slug === this.category)) {
          let c = res.find(x => x.slug === this.category)
          return (this.catInfo = c)
        } else {
          alert('Järjestelmävirhe! Sivua ei voi näyttää :( (loadingCa)')
          return {}
        }
      })
      .catch(e => {
        alert('Järjestelmävirhe! Sivua ei voi näyttää :( (loadingCa) ' + e)
        this.error = true
      })
      .finally(() => {
        this.loadingCa = false
        fetch(
          `https://hallinta.kotona.kiuruvesi.net/fontend/companies/${this.catInfo.backend}`
        )
          .then(res => res.json())
          .then(res => {
            return (this.companies = { ...res })
          })
          .catch(e => {
            alert('Järjestelmävirhe! Sivua ei voi näyttää :( (loadingCo) ' + e)
            this.error = true
          })
          .finally(() => (this.loadingCo = false))
      })
  },
  methods: {
    openText(c) {
      // https://stackoverflow.com/a/24481597
      let openToday = c.openHours[(new Date().getDay() + 6) % 7].toLowerCase()
      return openToday === 'suljettu'
        ? 'Tänään suljettu'
        : `Avoinna tänään ${openToday}`
    },
    htmlInfo(c) {
      return c.infoText
        .replace(
          // eslint-disable-next-line no-useless-escape
          /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g,
          // eslint-disable-next-line no-console
          t => `<a target="_blank" href="${t}">${t}</a>`
        )
        .replace(/\n/g, '<br>')
    }
  },
  data: () => ({
    error: false,
    expansionPanels: {},
    loadingCa: true,
    loadingCo: true,
    catInfo: {
      name: 'Järjestelmävirhe',
      slug: 'ruokaa',
      infoText:
        'Jokin meni pieleen! Ilmoita tästä sähköpostilla osoitteeseen vili@pysykotona.fi !'
    },
    companies: []
  })
}
</script>
